import { PathwayStateType_Assessment } from '../../_enum/index.js';
export const generateNewPathwayState = (pathwayId) => {
    return {
        pathwayIds: [pathwayId],
        label: 'New State',
        name: 'New State',
        type: PathwayStateType_Assessment,
        expressionIds: [],
        dds: [],
        preconditions: [],
    };
};
//# sourceMappingURL=consts.js.map